import React from 'react'
import cl from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    tab: {
        fontSize: 14,
        textTransform: 'none',
        fontWeight: 'normal',
        color: theme.textPrimary,
        fontFamily: theme.fontFamily
    },
    tabIndicator: {
        backgroundColor: theme.primary,
        height: 3
    },
    tabs: {
        borderBottom: theme.border
    },
    tabOverride: {
        minWidth: 0
    }
}))

export default function CustomTabs(props) {
    const classes = useStyles()
    const theme = useSelector(state => state.main.theme)

    const {
        currentTab,
        tabs,
        className,
        tabClasses,
        setCurrentTab,
        ...rest
    } = props

    const onTabChange = (event, value) => setCurrentTab(value)

    return (
        <Tabs
            classes={{ indicator: classes.tabIndicator }}
            className={cl(classes.tabs, className)}
            value={currentTab}
            onChange={onTabChange}
            centered
            {...rest}
        >
            {Object.keys(tabs).map(key => {
                return (
                    <Tab
                        classes={{ root: classes.tabOverride, ...tabClasses }}
                        key={key}
                        label={
                            <span className={classes.tab}>
                                {tabs[key].withBetaBadge ? (
                                    <span
                                        style={{
                                            color: theme.textPrimaryReverted,
                                            backgroundColor: `${theme.active}94`,
                                            padding: '2px 8px',
                                            borderRadius: theme.borderRadius,
                                            marginRight: 4
                                        }}
                                    >
                                        Beta
                                    </span>
                                ) : null}
                                {tabs[key].name}
                            </span>
                        }
                        value={key}
                        disabled={tabs[key].disabled}
                    />
                )
            })}
        </Tabs>
    )
}
